import { render, staticRenderFns } from "./_videoList.vue?vue&type=template&id=633c5054&scoped=true"
import script from "./_videoList.vue?vue&type=script&lang=js"
export * from "./_videoList.vue?vue&type=script&lang=js"
import style0 from "./_videoList.vue?vue&type=style&index=0&id=633c5054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c5054",
  null
  
)

export default component.exports